import { getTimeClass } from '@mews-commander/utils';
import { WithEnterpriseId } from '@mews-commander/types';
import { useCurrentServiceIdContext } from '../../../../contexts';
import { useLocalPaymentPolicyOptions } from '../../queries/useLocalPaymentPolicyOptions';
import { useLocalCancellationPolicyOptions } from '../../queries/useLocalCancellationPolicyOptions';
import { useSelectedService } from '../../hooks/useSelectedService';
import { PolicyFields } from './PolicyFields';

interface PolicyFieldsProps extends WithEnterpriseId {
    settlementCurrencyCode: string;
}

export const LocalPolicyFields = ({ settlementCurrencyCode, enterpriseId }: PolicyFieldsProps) => {
    const serviceId = useCurrentServiceIdContext();
    const service = useSelectedService({ enterpriseId, serviceId });

    const paymentPolicyOptionsQuery = useLocalPaymentPolicyOptions({
        enterpriseId,
        settlementCurrencyCode,
    });
    const cancellationPolicyOptionsQuery = useLocalCancellationPolicyOptions({
        enterpriseId,
        bookablePeriod: service ? getTimeClass(service) : undefined,
    });

    return (
        <PolicyFields
            paymentPolicyOptionsQuery={paymentPolicyOptionsQuery}
            cancellationPolicyOptionsQuery={cancellationPolicyOptionsQuery}
        />
    );
};
